import React, { useEffect, useState } from "react";

import moment from "moment";

import { useUser, usePopup, useData, useMenu, useLang } from "../zustand/store.js";

import { LangText } from "../zustand/dict.js";
// import { lang } from '../utils/utils';
import consts from '../libs/consts';
import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import InputSimple from '../components/InputSimple.js';
import Button from '../components/Button';
import Selector from '../components/Selector';
import RadioImage from "../components/RadioImage";
import Radio from "../components/Radio";
import InputRange from "../components/InputRange";
import { useNavigate } from "react-router-dom";

export default function Menu5() {
    const navigate = useNavigate();

    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();
    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();

    const [prompt, setPrompt] = useState("headshot, portrait");
    const [seed, setSeed] = useState("");
    const [selected, setselected] = useState(1);
    const [styleIndex, setStyleIndex] = useState(0);
    const [isStyleUpload, setIsStyleUpload] = useState(false);
    const [moreView, setMoreView] = useState(false)

    const [slide1, setSlide1] = useState(50);
    const [slide2, setSlide2] = useState(50);
    const [slide3, setSlide3] = useState(50);

    return (
        <>
            <div className="content">
                사용하지 않음
            </div>
        </>
    );
}
